module.exports = __webpack_public_path__ + "bed-bubble.41006b3c.png";